import { cn } from '@/lib/utils/helpers'

export function EmailTemplateToggleButton({
  selected,
  onClick,
  children,
  testId,
}: {
  selected: boolean
  onClick: () => void
  children: React.ReactNode
  testId?: string
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={cn(
        'min-w-[4.75rem] rounded-lg border px-4 py-2 text-sm font-medium shadow-sm transition',
        selected
          ? 'border-[#1597ff] bg-[#1597ff] text-white'
          : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50',
      )}
    >
      {children}
    </button>
  )
}
